import React from "react";
import { useParams } from "react-router-dom";
import { TermType, useGetTerm } from "../../../utils/useTerm";
import {
  useDeleteGameSelection,
  useGetGameSelection,
  useShuffleGameSelection,
  useUpdateGameSelection,
} from "../../../utils/useGameSelection";
import GameSelectionDetail from "./GameSelectionDetail";
import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";
import { SonicGameSelectionItem } from "../../../common/classes/SonicGameSelection";

const GameSelectionDetailContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const auth_token = useAppSelector(getAuthToken);

  const { termData: terms, getTermLoading: gameLoading } = useGetTerm(
    TermType.Games,
    undefined,
    -1,
    undefined
  );
  const { gameSelections, isLoading } = useGetGameSelection();

  const { mutateAsync, mutateLoading } = useUpdateGameSelection();

  const handleUpdate = async (
    game_id: string,
    item: SonicGameSelectionItem
  ) => {
    if (auth_token) {
      await mutateAsync({
        authToken: auth_token,
        game_id: game_id,
        rank: item,
      });
    }
  };

  const { deleteAsync, deleteLoading } = useDeleteGameSelection();

  const handleDelete = async (id: string, field: string, itemId: string) => {
    if (auth_token) {
      await deleteAsync({
        authToken: auth_token,
        id: id,
        field_name: field,
        item_id: itemId,
      });
    }
  };

  const { shuffleAsync, shuffleLoading } = useShuffleGameSelection();

  const handleShuffle = async (
    id: string,
    field: string,
    shuffledIndex: Array<number>
  ) => {
    if (auth_token) {
      await shuffleAsync({
        authToken: auth_token,
        id: id,
        field_name: field,
        shuffled_index: shuffledIndex,
      });
    }
  };

  return (
    <GameSelectionDetail
      isLoading={
        isLoading ||
        gameLoading ||
        mutateLoading ||
        deleteLoading ||
        shuffleLoading
      }
      game={terms.entries.filter((term) => term.id === id)[0]}
      gameSelection={
        gameSelections.filter((selection) => selection.game_id === id)[0]
      }
      handleUpdate={handleUpdate}
      handleDelete={handleDelete}
      handleShuffle={handleShuffle}
    />
  );
};

export default GameSelectionDetailContainer;
